/**
 * Перечень медицинских программ
 *
 * @param {Object} params
 * @param {String} params.showGroupId - id открытия группы медицинских программ
 * @param {String} params.groupMedicalPrograms - группа медицинских программ определенного тега
 * @param {String} params.groupMedicalProgramsSelect - селектор для выбора группы медицинских программ
 */
$.fn.medicalProgramsList = function (params) {

    const $self = $(this);
    const showGroupId = params.showGroupId;
    const groupMedicalPrograms = params.groupMedicalPrograms;
    const groupMedicalProgramsSelect = params.groupMedicalProgramsSelect;

    /**
     * Выбор группы медицинских программ
     */
    $self.on('click', groupMedicalProgramsSelect, function () {
        let currentGroupMedicalPrograms = $(this).attr(showGroupId);
        hideAllGroupsMedicalPrograms();
        $self.find('#' + currentGroupMedicalPrograms).show();
    });

    /**
     * Скрытие всех групп медицинских программ
     */
    const hideAllGroupsMedicalPrograms = function () {

        $self.find(groupMedicalPrograms).each(function () {
            $(this).hide();
        });
    };

    return this;
};

// инициализация
const init = function () {

    $('#medical-programs-list-module').medicalProgramsList({
        showGroupId: 'data-show-group-id',
        groupMedicalPrograms: '.js-group-medical-programs',
        groupMedicalProgramsSelect: '.js-select-group-medical-programs',
    });
};

if ($('#medical-programs-list-module').length > 0) {
    init();
}